<!-- eslint-disable no-multi-assign -->
<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">
      <h5 class="card-title fw-bold mb-0">Top 10 Villes ( Colis Livré)</h5>
      <div class="row">
        <div class="col-md-8">
          <!-- <rangedate-picker
            ref="myInput"
            format="YYYY-MM-DD"
            i18n="EN"
            :preset-ranges="presetRanges"
            :captions="captions"
          /> -->
        </div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn btn-primary mr-2"
            @click="FilterData"
          >
            <i class="flaticon-search"></i>
          </button>
          <button type="button" class="btn btn-danger" @click="ClearFilterData">
            <i class="flaticon-close"></i>
          </button>
        </div>
      </div>
      <div :style="[display ? { display: 'none' } : '']" class="chart">
        <apexchart
          type="bar"
          height="325"
          :options="productOrdersRadialBar.chartOptions"
          :series="productOrdersRadialBar.series"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import api from "@/utils/axios";
import { ref, reactive, defineComponent } from "vue";
export default defineComponent({
  name: "ChartCitieStatistics",
  setup() {
    const display = ref(true);
    const searchEDate = ref("");
    const searchSDate = ref("");
    const productOrdersRadialBar = reactive({
      series: [
        {
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      noData: {
        text: "No data text",
        align: "center",
        verticalAlign: "middle",
      },
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: [
          "#E25309",
          "#A009E2",
          "#097AE2",
          "#09E2B1",
          "#A5978B",
          "#B97B08",
          "#f9a3a4",
          "#90ee7e",
          "#f48024",
          "#69d2e7",
        ],
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter(val, opt) {
            return `${val} Colis`;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
      },
    });

    function convert(date) {
      // Example conversion, adjust as needed
      return date ? new Date(date).toISOString().slice(0, 10) : "";
    }

    async function getData() {
      try {
        const res = await api.get(
          `/api/auth/client/CitiesCount?searchSDate=${searchSDate.value}&searchEDate=${searchEDate.value}`
        );
        display.value = false;
        productOrdersRadialBar.series[0].data = res.data.totals;
        productOrdersRadialBar.chartOptions.xaxis.categories = res.data.labels;
      } catch (error) {
        // handle error if needed
      }
    }

    async function FilterData() {
      const input = this?.$refs?.myInput;
      searchSDate.value = input?.dateRange?.start
        ? convert(input.dateRange.start)
        : "";
      searchEDate.value = input?.dateRange?.end
        ? convert(input.dateRange.end)
        : "";
      await getData();
    }

    async function ClearFilterData() {
      searchSDate.value = "";
      searchEDate.value = "";
      const input = this?.$refs?.myInput;
      if (input) input.dateRange = {};
      await getData();
    }

    return {
      productOrdersRadialBar,
      display,
      searchEDate,
      searchSDate,
      FilterData,
      ClearFilterData,
      getData,
    };
  },
});
</script>